import React, {useContext, useMemo} from 'react';
import {AutomationDropdown} from '../../components/AutomationsDropdown';
import {getSettingsItems} from '../../components/AutomationsDropdown/constants';
import {MacrosButtons} from '../../components/Macros/MacrosButtons';
import {Form} from '../../../../stores/Form';
import {RuleDialog} from '../../components/RuleDialog/RuleDialog';
import {RuleType} from '../../enums';
import {MacroModal} from '../../components/Macros/MacroModal';
import {RulesListDialog} from '../../components/RulesListDialog/RulesListDialog';
import {DialogToolbarContent} from '../../../../components/Dialog/DialogToolbar/DialogToolbar';
import {getOpenRuleDialogTitle, getOverviewDialogTitle} from './utils';
import {AutomationContext} from '../../context';
import {texts} from '../../texts';
import {overviewDialogID} from '../../constants';
import styles from '../../../../features/Form/components/FormToolbar/style.module.scss';
import {BusinessRuleListHelp} from '../../components/RulesListDialog/consts';

type Props = {
    form: Form;
    componentClasses?: string;
    disabled?: boolean;
    macroSubmenu?: boolean;
};

export const AutomationModuleView = ({form, componentClasses, disabled, macroSubmenu}: Props) => {
    const {
        isAutomationOpen,
        automationType,
        singleRuleOpen,
        closeAutomation,
        openAutomationList,
        useBridgeAPI
    } = useContext(AutomationContext);
    const settingsItems = useMemo(getSettingsItems, []);

    const renderModals = () => {
        if (singleRuleOpen) {
            return (
                <RuleDialog
                    session={form?.session}
                    currentFormTitle={form?.title}
                    type={automationType}
                    isOpen={singleRuleOpen}
                    title={getOpenRuleDialogTitle(automationType)}
                    subtitle={form?.title || ''}
                    help={
                        automationType === RuleType.autofill
                            ? texts.single_autofill_rule_help
                            : texts.single_business_rule_help
                    }
                />
            );
        }

        if (automationType === RuleType.macro) {
            return <MacroModal onClose={closeAutomation} />;
        }

        const shouldShowRulesDialog = automationType !== RuleType.empty;

        if (shouldShowRulesDialog) {
            const monitorTransactionText =
                automationType === RuleType.business ? BusinessRuleListHelp : '';

            return (
                <RulesListDialog
                    session={form?.session}
                    type={automationType}
                    onClose={closeAutomation}
                    isOpen={shouldShowRulesDialog}
                    isLoading={!isAutomationOpen}
                    toolbarContent={
                        <DialogToolbarContent
                            mainTitle={getOverviewDialogTitle(automationType)}
                            subTitle={form?.title?.toLocaleLowerCase()}
                            helpText={texts.general_automation_list_dialog_help}
                            tooltipPortalID={overviewDialogID}
                            monitorTransactionText={monitorTransactionText}
                        />
                    }
                />
            );
        }
        return null;
    };

    return (
        <div>
            <AutomationDropdown
                onSelect={openAutomationList}
                settingsItems={settingsItems}
                componentClasses={componentClasses}
                contentComponentClasses={styles.automationDropdownContent}
                useBridgeAPI={useBridgeAPI}
                form={form}
                disabled={disabled}
                macroSubmenu={macroSubmenu}
            />

            {renderModals()}
            <MacrosButtons />
        </div>
    );
};
